import { render, staticRenderFns } from "./AddToJDSuceessMultiple.vue?vue&type=template&id=1851054b&"
import script from "./AddToJDSuceessMultiple.vue?vue&type=script&lang=js&"
export * from "./AddToJDSuceessMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports